import React, { Component } from 'react';

import TrashFull from '../../img/trash-full.svg'
import TrashEmpty from '../../img/trash.svg'
import TrashBiohazard from '../../img/trash-biohazard.svg'
import TrashBiohazardOpen from '../../img/trash-biohazard-open.svg'

const images = {
  TrashFull: TrashFull,
  TrashEmpty: TrashEmpty,
  TrashBiohazard: TrashBiohazard,
  TrashBiohazardOpen: TrashBiohazardOpen,
}


export class Graphics extends Component {

  getImage = ()=>{
    if(this.props.type === "Biohazard"){
      if(this.props.open){
        return images.TrashBiohazardOpen
      } else {
        return images.TrashBiohazard
      }

    } else {
      return (
        (this.props.full)?
          images[this.props.type+"Full"]:
          images[this.props.type+"Empty"]
      )
    }
  }

  getClass = () => {
    if(this.props.open){
      return "trash-open"
    } else {
      return "trash-closed"
    }
  }


  render(){
    return(
      <div aria-label="Trash can" className="graphics">
         <img
              style={{
                cursor: (this.props.type === "Biohazard")?
                          "pointer":
                          "initial"
              }}
             className={this.getClass()}
             src={this.getImage()}
             alt={'Trash'}/>
      </div>
    )
  }
}
